<!--
   Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
-->
<nav id="menu">
  <ul class="nav nav-pills flex-column sideMargin">
    <li role="presentation" class="inverse nav-item">
      <a routerLink="/home" class="nav-link">
        <span>
          <fa-icon [icon]="faDesktop" size="lg"></fa-icon>
        </span>
        Dashboard
      </a>
    </li>

    <li role="presentation" class="nav-item">
      <a routerLink="/merchants" class="nav-link">
        <span>
          <fa-icon [icon]="faMoney"></fa-icon>
        </span>
        Merchants
      </a>
    </li>
    <li role="presentation" class="submenu nav-item">
      <a routerLink="/merchants" class="nav-link">
        <span>
          <fa-icon [icon]="faSearch" size="sm"></fa-icon>
        </span>
        search for merchant
      </a>
    </li>
    <li role="presentation" class="submenu nav-item" *ngIf="hasFinanceRole">
      <a routerLink="/merchants/add" class="nav-link">
        <span>
          <fa-icon [icon]="faPlus" size="sm"></fa-icon>
        </span>
        add new merchant
      </a>
    </li>
    <li role="presentation" class="nav-item" *ngIf="hasOnboardingAccess">
      <a routerLink="/onboarding/initiate" class="nav-link">
        <span>
          <fa-icon [icon]="faCheckCircle"></fa-icon>
        </span>
        Onboarding
      </a>
    </li>
    <li role="presentation" class="submenu nav-item" *ngIf="hasOnboardingAccess">
      <a routerLink="/onboarding/initiate" class="nav-link">
        <span>
          <fa-icon [icon]="faPlus" size="sm"></fa-icon>
        </span>
        Initiate Merchant Application
      </a>
    </li>
    <li role="presentation" class="submenu nav-item" *ngIf="hasOnboardingAccess">
      <a class="nav-link">
        <span>
          <svg class="statusIcon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2-5a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </span>
        View Application Status
      </a>
    </li>
    <li role="presentation" class="toggle" (click)="hideMenu()">
      <span>
        <fa-icon [icon]="faChevronLeft" size="2x"></fa-icon>
      </span>
    </li>
  </ul>
</nav>
